import type * as React from 'react';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { withTranslation as withTranslationFunc } from 'react-i18next';

export const withTranslation: any = (
  component: React.ComponentType<WithTranslationProps>,
) => withTranslationFunc()(component);
